import { MenuItem, TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';

import useStyles from '../tablaDetallesPlantillaEstilos';

interface ICampoDivisionDestinoProps {
    deshabilitado: boolean;
    detalle: IDocumentoDetalleConsultaGeneral;
    divisiones: IBodegaDivisiones[];
    manejarCambioCampo: (
        detalleId: string,
        nombreCampo: keyof IDocumentoDetalleConsultaGeneral,
        nuevoValor: any
    ) => void;
}

const CampoDivisionDestino: FunctionComponent<ICampoDivisionDestinoProps> = ({
    deshabilitado,
    detalle,
    divisiones,
    manejarCambioCampo,
}) => {
    const classes = useStyles();

    return (
        <TextField
            classes={{ root: classes.campo }}
            disabled={deshabilitado}
            fullWidth
            label={<Texto id="TablaDetallesPlantilla.DivisionDestino" />}
            onChange={(event) => manejarCambioCampo(detalle.DocumentoDetalleId, 'DivisionDestino', event.target.value)}
            select
            size="small"
            value={detalle.DivisionDestino || ''}
            id={`CampoDivisionDestino-${detalle.DivisionDestino}`}
        >
            {divisiones.map((division) => (
                <MenuItem key={division.DivisionId} value={division.DivisionId}>
                    {division.DivisionDescripcion}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default CampoDivisionDestino;
